export function getClientDomain() {
  return "";
}
